<template>
  <div class="printable-content simple-paper text-sm">
    <!-- header informations -->
    <div class="grid grid-cols-2 mb-8 border-b border-slate-300 pb-4">
      <!-- uttrly informations -->
      <div>
        <div class="mb-4">
          <span class="block font-bold text-md mb-3">Uttrly</span>
          <span class="block mb-2">11810 Grand Park Ave, Suite 500</span>
          <span class="block mb-2">North Bethesda, MD 20852</span>
          <span class="block mb-2">202.681.0825</span>
          <span class="block">portal-admin@uttrly.com</span>
        </div>

        <div class="text-primary-700 font-semibold mb-4 text-2xl">
          <span class="uppercase">Bill</span>
        </div>

        <div class="text-base font-semibold mb-2">
          <span class="uppercase">From</span>
        </div>

        <!-- bill from -->
        <div>
          <span v-if="name" class="block mb-1">{{ name }}</span>
          <span v-if="address" class="block mb-1">{{ address }}</span>
        </div>
      </div>

      <!-- logo and bill header informations -->
      <div>
        <div class="flex justify-end mb-7">
          <img
            :src="logo"
            alt="Uttrly"
          />
        </div>
        <div class="text-right">
          <div class="grid grid-cols-4 gap-2">
            <span class="font-bold col-span-3 uppercase">Bill #</span>
            <span>{{ bill.billNumber }}</span>
          </div>

          <div class="grid grid-cols-4 gap-2">
            <span class="font-bold col-span-3 uppercase">DATE</span>
            <span>{{ getLocalDate(bill.billDate) }}</span>
          </div>

          <div class="grid grid-cols-4 gap-2">
            <span class="font-bold col-span-3 uppercase">Due DATE</span>
            <span>{{ getLocalDate(bill.dueDate) }}</span>
          </div>

          <div class="grid grid-cols-4 gap-2">
            <span class="font-bold col-span-3">TERMS</span>
            <span>Net 30</span>
          </div>
        </div>
      </div>
    </div>

    <div>
      <BaseTable
        :items="bill.items"
        :fields="billItemFields"
        class="mt-5"
        :show-footer="true"
      >
        <template #cost-data="{ row }">
          {{ currency(getCost(row)) }}
        </template>
        <template #total-header="{ column }">
          <span class="block text-center">{{ column.label }}</span>
        </template>
        <template #total-data="{ row }">
          <span class="block text-center">{{ currency(row.quantity * getCost(row)) }}</span>
        </template>

        <template #footer>
          <div class="flex items-center justify-end gap-2">
            <span class="font-bold uppercase">Balance due:</span>
            <span>{{ currency(bill.balance) }}</span>
          </div>
        </template>
      </BaseTable>
    </div>
  </div>
</template>

<script lang="ts" setup>
import logo from '@/assets/images/logo.png'
import { currency, getLocalDate } from '@/utils'
import { PropType } from 'vue'
import BaseTable from '@/components/base/BaseTable.vue'
import { Bill } from '@/models/bill'

const billItemFields = [
  { key: 'name', label: 'Items' },
  { key: 'cost', label: 'Price' },
  { key: 'quantity', label: 'Quantity' },
  { key: 'total', label: 'Total' }
]

defineProps({
  name: {
    type: String,
    required: true
  },
  address: {
    type: String,
    default: ''
  },
  bill: {
    type: Object as PropType<Bill>,
    required: true
  },
})

const getCost = (row: any) => {
  if (row.cost) {
    return row.cost
  } else if (row.unitPrice) {
    return row.unitPrice
  } else {
    return 0
  }
}
</script>



<style lang="scss" scoped>
.printable-content {
  width: 200mm !important; /* Largeur A4 */
  padding: 5mm !important; /* Marges */
  /* min-height: 257mm !important; Hauteur A4 */
  background: white;
}

.simple-paper {
  border: 0.7px solid #ccc;
  padding: 20px;
}
</style>
